import * as React from "react";
import { format } from "date-fns";

interface CalendarDateProps {
  date: Date
}

const CalendarDate: React.FC<CalendarDateProps> = (props) => {
  const day = format(props.date, "EEE");
  const date = format(props.date, "d");

  return (
    <div className="c-calendar-date text-center no-line-spacing">
      <div className="c-calendar-date__day bg-primary text-secondary text-uppercase fs-10">{day}</div>
      <div className="c-calendar-date__date bg-panel-light text-secondary fs-8 fw-6">{date}</div>
    </div>
  )
}

export default CalendarDate;
